// dashBoard/index.ts
import color from "./color.jpg";
import prompt from "./prompt.jpg";
import explore from "./explore.jpg";
import t2i from "./t2i.jpg";
import i2i from "./i2i.jpg";
import upscale from "./upscale.jpg";
import video from "./video.jpg";
import mindmap from "./mindmap.jpg";
import voice from "./voice.jpg";
import writing from "./writing.jpg";
import music from "./music.jpg";

const DashBoard = {
  color,
  prompt,
  explore,
  t2i,
  i2i,
  upscale,
  video,
  mindmap,
  voice,
  writing,
  music,
};

export default DashBoard;

// 個別エクスポート
export {
  color as dashBoardColor,
  prompt as dashBoardPrompt,
  explore as dashBoardExplore,
  t2i as dashBoardT2i,
  i2i as dashBoardI2i,
  upscale as dashBoardUpscale,
  video as dashBoardVideo,
  mindmap as dashBoardMindmap,
  voice as dashBoardVoice,
  writing as dashBoardWriting,
  music as dashBoardMusic,
};
